module.exports = __webpack_public_path__ + "assets/img/icon_3.378369cd.svg";